import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { ADD, EDIT, IDLE, PENDING } from "const"
import { StateType, hasAccess } from "client/utils"
import {
    PRM_MARKOV_MODEL,
    StoreType,
    MarkovModelProps,

    LoadMarkovModelById,

    setMarkovModelEdit,
    setMarkovModelReloadEdit,
    initMarkovModel,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import AccessDenied from "client/parts/accessDenied"
import Form from "./form"

const Edit = ({
    modelId = null,
}: MarkovModelProps) => {
    const model = useSelector((state: StoreType) => state.markovModel.modelEdit)
    const reloadEdit = useSelector((state: StoreType) => state.markovModel.reloadEdit)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setMarkovModelReloadEdit(false))
        setTimeout(() => {
            dispatch(setMarkovModelReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (modelId === 0) {
            dispatch(setMarkovModelEdit(initMarkovModel))
            reload()
        } else {
            setLoadState(PENDING)
            LoadMarkovModelById(modelId, userData.accountId).then((res) => {
                dispatch(setMarkovModelEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    const addAccess = hasAccess(PRM_MARKOV_MODEL, ADD)
    const editAccess = hasAccess(PRM_MARKOV_MODEL, EDIT)

    // TODO: edit access by "creator" ???

    if (modelId === 0 && !addAccess) return <AccessDenied />
    if (modelId !== 0 && !editAccess) return <AccessDenied />
    if (!model) return <NotFound />

    return (
        <Container>
            <PageHeader>
                <PageTitle>{model.id ? `${lang.editModel} # ${model.id}` : lang.addModel}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form model={model} />
                }
                {
                    reloadEdit
                    && <Form model={model} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
